export const BANNER_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
} as const;

export type TBannerStatus = typeof BANNER_STATUS[keyof typeof BANNER_STATUS];

export interface IBanner {
  id: string;
  position: string;
  name: string;
  image: string;
  link?: string;
  status: TBannerStatus;
  order?: number;
  createdById?: string;
  createdAt?: number;
  publishDate?: number | string;
  unpublishDate?: number | string;
}

export interface IBannerListParams {
  size?: number;
  after?: any[] | null | false;
  ids?: string[];
  q?: string;
  position?: string;
  status?: TBannerStatus | '';
}

export interface IBannerListData {
  items: IBanner[];
  next: any[] | null | false;
}

export interface IBannerCreateParams {
  position: string;
  name: string;
  image: string;
  link?: string;
  status?: TBannerStatus;
  order?: number;
  publishDate?: string;
  unpublishDate?: string;
}

export interface IBannerUpdateParams extends Partial<IBannerCreateParams> {
  id: string;
}

export interface IBannerFormModalResult {
  mode: 'create' | 'edit';
  params: IBannerCreateParams | IBannerUpdateParams;
}

export interface IBannerRemoveParams {
  id: string;
}

export interface IBannerItemData {
  item: IBanner;
}

export interface IBannerRemoveData {
  success: boolean;
}
